/**
 * Perkthen nje gabim te axios-it ne nje fjali qe perdoruesi e kupton.
 *
 * Me pare dilte vetem "Request failed with status code 500", qe nuk i thote
 * asgje as perdoruesit as atij qe e ndihmon: nuk dallohet nese mungon
 * interneti, nese serveri ra, apo nese fjalekalimi ishte gabim.
 *
 * Rregulli: mesazhi i serverit ka perparesi kur ekziston, sepse ai di me
 * shume se ne; perndryshe nxirret nga gjendja e rrjetit dhe kodi i pergjigjes.
 */

/** Teksti sipas gjuhes se zgjedhur, pa varesi nga vue-i18n. */
function sq() {
  try {
    return localStorage.getItem('locale') !== 'en';
  } catch (e) {
    return true;
  }
}

const TEKSTET = {
  sq: {
    pa_internet:
      'Nuk ka lidhje interneti. Kontrolloni Wi-Fi ose të dhënat celulare dhe provoni sërish.',
    pa_pergjigje:
      'Serveri nuk u përgjigj. Mund të jetë lidhja juaj ose serveri përkohësisht i paarritshëm.',
    skadoi:
      'Kërkesa zgjati shumë dhe u ndërpre. Lidhja duket e ngadaltë — provoni sërish.',
    kredenciale: 'Email-i ose fjalëkalimi nuk është i saktë.',
    sesioni: 'Sesioni juaj ka skaduar. Hyni sërish.',
    pa_leje: 'Nuk keni leje për këtë veprim.',
    nuk_u_gjet: 'Të dhënat e kërkuara nuk u gjetën.',
    shume_prova: 'Shumë përpjekje njëra pas tjetrës. Prisni pak dhe provoni sërish.',
    llogari_e_mbyllur: 'Kjo llogari është çaktivizuar. Kontaktoni shkollën.',
    gabim_serveri:
      'Problem në server. Nuk është faji juaj — provoni sërish pas pak.',
    server_i_zene:
      'Serveri është i zënë ose në mirëmbajtje. Provoni sërish pas disa minutash.',
    i_panjohur: 'Diçka shkoi keq. Provoni sërish.',
  },
  en: {
    pa_internet:
      'No internet connection. Check your Wi-Fi or mobile data and try again.',
    pa_pergjigje:
      'The server did not respond. It may be your connection, or the server is temporarily unreachable.',
    skadoi: 'The request took too long and was cancelled. Your connection seems slow.',
    kredenciale: 'The email or password is incorrect.',
    sesioni: 'Your session has expired. Please sign in again.',
    pa_leje: 'You do not have permission for this action.',
    nuk_u_gjet: 'The requested data was not found.',
    shume_prova: 'Too many attempts in a row. Please wait a moment and try again.',
    llogari_e_mbyllur: 'This account has been disabled. Please contact the school.',
    gabim_serveri: 'Server problem. This is not your fault — please try again shortly.',
    server_i_zene: 'The server is busy or under maintenance. Try again in a few minutes.',
    i_panjohur: 'Something went wrong. Please try again.',
  },
};

function t(celes) {
  return (sq() ? TEKSTET.sq : TEKSTET.en)[celes];
}

/**
 * Kycja kalon neper Firebase, dhe gabimet e tij nuk jane te axios-it: nuk
 * kane `response`. Pa kete tabele, nje fjalekalim i gabuar binte te dega
 * "pa pergjigje" dhe perdoruesit i thuhej se serveri nuk u pergjigj —
 * ndersa serveri as nuk ishte pyetur.
 */
const FIREBASE = {
  'auth/invalid-credential': 'kredenciale',
  'auth/invalid-login-credentials': 'kredenciale',
  'auth/wrong-password': 'kredenciale',
  'auth/user-not-found': 'kredenciale',
  'auth/invalid-email': 'kredenciale',
  'auth/missing-password': 'kredenciale',
  'auth/user-disabled': 'llogari_e_mbyllur',
  'auth/too-many-requests': 'shume_prova',
  'auth/network-request-failed': 'pa_internet',
};

/** Mesazhi qe dergon vete serveri, nese ka. */
function ngaServeri(data) {
  if (!data || typeof data !== 'object') return null;

  // Laravel: {"errors": {"email": ["..."]}} ose {"message": "..."}
  if (data.errors && typeof data.errors === 'object') {
    const i = Object.values(data.errors)[0];
    const teksti = Array.isArray(i) ? i[0] : i;
    if (typeof teksti === 'string' && teksti.trim()) return teksti;
  }

  if (typeof data.message === 'string' && data.message.trim()) {
    // Mesazhet e brendshme te Laravel-it jane ne anglisht dhe nuk i thone
    // asgje perdoruesit: zevendesohen me tekstin tone.
    if (
      /^(Server Error|Unauthenticated\.?|Unauthorized|Too Many Attempts\.?|Not Found|Forbidden|This action is unauthorized\.?)$/i.test(
        data.message.trim()
      )
    ) {
      return null;
    }
    return data.message;
  }

  return null;
}

/**
 * @param {object} error  gabimi i axios-it
 * @returns {string} nje fjali e kuptueshme
 */
export function mesazhiIGabimit(error) {
  if (!error) return t('i_panjohur');

  // 1. Shfletuesi e di qe nuk ka rrjet.
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return t('pa_internet');
  }

  // 2. Kerkesa u nis por nuk erdhi asnje pergjigje: rrjet i keputur, server
  //    i paarritshem, ose e nderpreme nga koha.
  if (error.code === 'ECONNABORTED' || /timeout/i.test(error.message || '')) {
    return t('skadoi');
  }

  if (typeof error.code === 'string' && error.code.indexOf('auth/') === 0) {
    return t(FIREBASE[error.code] || 'i_panjohur');
  }

  if (!error.response) {
    return t('pa_pergjigje');
  }

  const status = error.response.status;
  const iServerit = ngaServeri(error.response.data);

  // 3. Per gabimet e kerkeses, serveri e shpjegon me sakte se ne.
  if (status === 422 || status === 400) {
    return iServerit || t('i_panjohur');
  }

  switch (status) {
    case 401:
      return iServerit || t('kredenciale');
    case 419:
      return t('sesioni');
    case 403:
      return iServerit || t('pa_leje');
    case 404:
      return iServerit || t('nuk_u_gjet');
    case 429:
      return iServerit || t('shume_prova');
    case 500:
      return t('gabim_serveri');
    case 502:
    case 503:
    case 504:
    // Kodet e Cloudflare-it kur nuk e mberrin dot serverin tone. Perdoruesi
    // e sheh si gabim serveri, por shkaku eshte zakonisht rruga e rrjetit.
    case 520:
    case 521:
    case 522:
    case 523:
    case 524:
      return t('server_i_zene');
    default:
      return iServerit || t('i_panjohur');
  }
}

export default mesazhiIGabimit;
